export const defaults = {
    appendLocation: 'body',
};

export default defaults;
